<template>
<div>
<!--  分销导出export1  分销详情 detail1-->
  <div>
    <el-form @submit.native.prevent inline label-width="100px">
<!--          <el-form-item label="订单号:">-->
<!--            <el-input v-model="searchData.ChildOrderNo" placeholder="子订单号"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="营客通订单号">
            <el-input v-model="searchData.ChildOrderNo" placeholder="营客通订单号"></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="searchData.SkuName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="分销账号:">
            <el-input v-model="searchData.DistributorUserName" placeholder="请输入分销账号"></el-input>
          </el-form-item>
          <el-form-item label="下单用户:">
            <el-input v-model="searchData.DistributorUserName" placeholder="下单用户"></el-input>
          </el-form-item>

            <el-form-item label="订单状态">
              <el-select v-model="searchData.Status" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

<!--        <el-col :span="6">-->
<!--          <el-form-item label="供应商" prop="SupplierId">-->
<!--            <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"-->
<!--                       :remote-method="querySupplier" style="width:100%">-->
<!--              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
          <el-form-item label="支付时间：">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
                            style="width:100%">
            </el-date-picker>
          </el-form-item>
      <!--        <el-form-item label="采购单号:">-->
      <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号"></el-input>-->
      <!--        </el-form-item>-->
      <el-form-item>
      </el-form-item>
    </el-form>
    <div style="display: flex;margin:15px;">
      <el-button type="primary" @click="searchFun">查询</el-button>
      <el-button @click="resetFun">重置</el-button>
      <el-button v-if="isExportShow" type="primary" @click="export1">导出</el-button>
      <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
    </div>
    <el-table @selection-change="selectCurrentRow" :data="tableList" highlight-current-row element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
              style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column label="订单状态" width="300" align="center">
        <template slot-scope="scope">
          <div style="padding:2px;display: inline-block"><el-tag  v-if="scope.row.status == '10'">待支付</el-tag></div>
          <div style="padding:2px;display: inline-block"> <el-tag v-if="scope.row.status == '20'">备货中(待发货)</el-tag></div>
          <div style="padding:2px;display: inline-block"> <el-tag v-if="scope.row.status == '30'">待收货(已发货)</el-tag></div>
          <div style="padding:2px;display: inline-block"><el-tag v-if="scope.row.status == '40'">已收货</el-tag></div>
          <div style="padding:2px;display: inline-block"> <el-tag v-if="scope.row.status == '50'">已完成</el-tag></div>
          <div style="padding:2px;display: inline-block"> <el-tag v-if="scope.row.status == '60'">已取消</el-tag></div>
          <div style="padding:2px;display: inline-block">  <el-tag v-if="scope.row.status == '70'">已关闭</el-tag></div>
          <div style="padding:2px;display: inline-block"> <el-tag type="danger" v-if="scope.row.isHaveExecingAfter">售后进行中</el-tag></div>








        </template>
      </el-table-column>
      <el-table-column label="分销账号" prop="distributorUserName" width="150" align="center">
<!--        <template slot-scope="scope">-->
<!--          <span v-if="Array.isArray(scope.row.orderPurchases) && scope.row.orderPurchases.length > 0">{{-->
<!--              scope.row.orderPurchases[0].orderPurchaseNo-->
<!--            }}</span>-->

<!--          &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->

<!--        </template>-->
      </el-table-column>
      <el-table-column prop="childOrderNo" label="营客通订单号" align="center" min-width="200"></el-table-column>
      <el-table-column prop="distributorCompanyName" label="下单用户" width="200" align="center"></el-table-column>
      <el-table-column prop="skuName" label="商品名称" width="200" align="center"></el-table-column>
      <el-table-column label="型号" prop="modelCode" width="250" align="center">
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;"> {{-->
<!--              scope.row.orderItems &&-->
<!--              scope.row.orderItems[0] && scope.row.orderItems[0].productSkuName-->
<!--            }}</span>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="skuSpecs" label="规格" align="center" width="120">
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;">{{-->
<!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
<!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
<!--            }}</span>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column label="购买数量" prop="skuNumber" align="center" width="120">
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;">{{-->
<!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
<!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
<!--            }}</span>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="skuPrice" label="分销价格" width="150" align="center">
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;"> {{-->
<!--              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
<!--            }}</span>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop='profitAmount' label="可赚金额" width="150" align="center">
<!--        <template slot-scope="scope">-->
<!--          {{-->
<!--            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
<!--          }}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="stock" label="收货人信息" width="120" align="center">
        <template slot-scope="scope">
         {{scope.row.receiverName}}
         {{scope.row.receiverPhone}}
         {{scope.row.receiverAddress}}
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="120" align="center">
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;"> {{-->
<!--              scope.row.orderItems &&-->
<!--              scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice-->
<!--            }}</span>-->
<!--        </template>-->
      </el-table-column>
<!--      <el-table-column prop="creationTime" label="数量" width="200" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span style="display: inline-block;margin-right:10px;"> {{-->
<!--              scope.row.orderItems &&-->
<!--              scope.row.orderItems[0] && scope.row.orderItems[0].quantity-->
<!--            }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="payTotalAccount" label="订单金额" width="200" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--                        <span style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice)  *-->
        <!--                            (scope.row.orderItems &&    scope.row.orderItems[0] && scope.row.orderItems[0].quantity)-->
        <!--                          }}</span>-->
        <!--          </template>-->
<!--      </el-table-column>-->
      <!--        <el-table-column prop="lastModificationTime" label="优惠信息" width="200" align="center"></el-table-column>-->
<!--      <el-table-column prop="payTotalAccount" label="支付时间" width="200" align="center"></el-table-column>-->
<!--      <el-table-column fixed="right" prop="payTotalAccount" label="操作" width="200" align="center">-->
<!--        <template>-->
<!--          <el-button @click="detail1" v-if="isDetailShow" type="primary" size="medium">详情</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
  </div>
</div>
</template>
<script>
import Toolbar from "../../../../components/Toolbar.vue";
import {getButtonList} from "../../../../promissionRouter";
import {DistributionOrderList, ExportDistributionOrderList, ProductSkuExport} from "../../../../api/api";

export default {
  components: {Toolbar},
  data(){
    return {
      options: [{
        value: '10',
        label: '待支付'
      }, {
        value: '20',
        label: '备货中(待发货)'
      }, {
        value: '30',
        label: '待收货(已发货)'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      isExportShow:false,
      isDetailShow:false,
      total:null,
      tableList:[],
      valueTime: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName:'',
        DistributorUserName: null,
        receivingName: null,
        receivingMobile: null,
        orderPurchaseNo: null,
        Status: null,
        OutOrderNo: "",
        SupplierId: ""
      },
    }
  },
  mounted() {
    console.log(1)
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      console.log('buttonList', buttonList);
      this.buttonList_toolBar = toolBarButtonList;
      this.buttonList_toolBar && this.buttonList_toolBar.forEach((item) => {
        if (item.buttonFunc === 'export1'){
          this.isExportShow = true;
        }
        if (item.buttonFunc === 'detail1'){
          this.isDetailShow = true;
        }
      })
      // const tableButtonList = buttonList.filter((item) => {
      //   return item.buttonShow === 20;
      // });
      // this.buttonList_table = tableButtonList;
    }
  },
  created(){
    this.getList()
  },
  methods: {
    async getList(){
      let res = await DistributionOrderList(this.searchData);
      console.log('res' ,res)
      if (res.data.success){
        // this.tableList = res.data.result.data.data;
        // this.total = res.data.result.data.dataCount;
        if (res.data.result.data.data){
          this.tableList =  res.data.result.data.data;
          this.total = res.data.result.data.dataCount;
        }
      }else {
        this.$message.error(res.data.error.message)
      }
      console.log('res', res);
    },
    async export1(){
      ExportDistributionOrderList(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '分销订单列表.xlsx'  //后缀名一定要写对，不然会导致文件损坏，打不开
        a.href = objectUrl
        a.click()
        a.remove()
        console.log(res, '???????????')
      })
      // let res = await ExportDistributionOrderList(this.searchData);
      // if (res.data.success) {
      //   this.$message.success('请前往下载中心查看！')
      // } else {
      //   this.$message.error(res.data.msg)
      // }

    },
    detail1(){},
    selectCurrentRow(val) {
      // this.currentRow = val;
    },
    handleCurrentChange(val) {
      // this.searchData.PageIndex = val;
      // this.getTableList();
    },
    handleSizeChange(e) {
      // this.searchData.PageSize = e;
      // this.getTableList();
    },
    searchFun(){
      this.PageIndex = 1;
      this.getList();
    },
    resetFun(){
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName:'',
        DistributorUserName: null,
        receivingName: null,
        receivingMobile: null,
        orderPurchaseNo: null,
        Status: null,
        OutOrderNo: "",
        SupplierId: ""
      };
      this.valueTime = [];
      this.getList();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.CreationStartTime = null;
        this.searchData.CreationEndTime = null;
      } else {
        this.searchData.CreationStartTime = e[0];
        this.searchData.CreationEndTime = e[1];
      }
    },
  }
}
</script>



<style scoped>

</style>